export default __webpack_public_path__ + "static/media/wxdai-tequila.81509e5d.png";